const DEFAULT_STATIC_OPTION = {
	context: null,
	title: null,
	url: null,
	param: null,
	loadOnStart: true,
	indexing: true,
	showNum: 10,
	sortField: null,
	sortDesc: true,
	bodyRowHeight: 40,
	showHeader: true,
	showFilterBar: true,
	searchSelectWidth: 120,
	searchBarSearchIcon: true,
	searchBarSearchButton: true,
	storeFilterButton: false,
	defaultEnableEditable: false,
	afterLoad: null,
	beforeLoad: null,
	quickfilterOption: [],
	rowValidator: null,

	list: [],
	fixedRowData: null,
	loading: false,
	p_selectIndex: null,
	page: 1,
	pageSize: 10,
	sizeOption: [5, 10, 20, 50],
	noPaging: null,
	singleFiltersRaw: null,
	filterOptions: [],
	renderColumns: null,
	quickfilterOptions: [],
	quickfilterType: 'check',
	quickfilterValue: [],
	staticTable: null,

	listData: [],
}

const component = {
	data() {
		const defaultStaticOption = this.$lv.$utils.deepCopy(StaticOption.DEFAULT_STATIC_OPTION)
		return {
			...defaultStaticOption
		}
	},
	watch: {
		list() {
			this.refreshListData()
		},
	},
	computed: {
		/**
		 * 静态筛选参数
		 * @author  韦胜健
		 * @date    2019/5/6 17:28
		 */
		filtersRaw() {
			let singleFiltersRaw = this.singleFiltersRaw || []
			this.$lv.$utils.typeOf(singleFiltersRaw) === 'object' && (singleFiltersRaw = [singleFiltersRaw])
			return singleFiltersRaw.concat(this.quickfilterValue || [])
		},
		/**
		 * 筛选、排序、分页后的数据
		 * @author  韦胜健
		 * @date    2019/5/6 17:29
		 */
		pageData() {
			if (this.noPaging) {
				return this.listData
			}
			let data = this.listData
			/*分页*/
			if (!!this.page && !!this.pageSize) {
				data = data.slice((this.page - 1) * this.pageSize, (this.page) * this.pageSize)
			}
			return data
		},
		/**
		 * 请求参数
		 * @author  韦胜健
		 * @date    2019/5/6 17:29
		 */
		targetParam() {
			return Object.assign({
				pageFlag: false,
				sort: this.sortField,
				order: this.sortDesc ? 'desc' : 'asc'
			}, this.param)
		},
		/**
		 * 当前选中行
		 * @author  韦胜健
		 * @date    2019/8/28 11:15
		 */
		selectRow() {
			if (this.p_selectIndex == null) return null
			return this.pageData[this.p_selectIndex]
		},
		/**
		 * 当前选中行索引
		 * @author  韦胜健
		 * @date    2019/8/28 11:21
		 */
		selectIndex() {
			if (this.p_selectIndex == null) return null
			return (this.page - 1) * this.pageSize + this.p_selectIndex
		},
		/**
		 * 总页数
		 * @author  韦胜健
		 * @date    2019/5/6 17:29
		 */
		totalPage() {
			if (!this.listData || this.listData.length === 0) return 0
			if (this.pageSize === 0) return 0
			return Math.ceil(this.listData.length / this.pageSize)
		},
		/**
		 * 快速筛选的option
		 * @author  韦胜健
		 * @date    2019/4/25 20:54
		 */
		p_quickfilterOption() {
			const ret = this.quickfilterOption.concat(this.quickfilterOptions)
			return ret.length > 0 ? ret : null
		},
	},
	mounted() {

	},
	methods: {
		/**
		 * 校验编辑
		 * @author  韦胜健
		 * @date    2019/5/6 17:30
		 */
		validate() {
			if (!this.list || this.list.length === 0) return null
			const columns = this.staticTable.$refs.table.columns

			for (let i = 0; i < this.list.length; i++) {
				const rowData = this.list[i];
				for (let j = 0; j < columns.length; j++) {
					const column = columns[j];
					let {field, title, required, rules, requiredFunc} = column
					if (!!requiredFunc) {
						required = requiredFunc({
							row: rowData,
							editRow: rowData,
							rowIndex: i,
							field,
						})
					}

					const valid = this.$rule.validate(rowData[field], required, rules)
					if (!!valid) {
						return {
							validate: false,
							msg: `第 ${i + 1} 条数据校验不通过，${title} ${valid.msg}`,
							rowIndex: i,
							title,
							validateMsg: valid.msg,
						}
					}
				}
				if (!!this.rowValidator) {
					const valid = this.rowValidator(rowData)
					if (!!valid) {
						return {
							validate: false,
							msg: `第 ${i + 1} 条数据校验不通过，${valid.msg}`,
							rowIndex: i,
							title: '',
							validateMsg: valid.msg,
						}
					}
				}
			}
			return null
		},
		/**
		 * 重新查询数据
		 * @author  韦胜健
		 * @date    2019/5/6 17:30
		 */
		async reload() {
			!!this.beforeLoad && (await this.beforeLoad.apply(this.context, [this.targetParam]))
			const data = await this.pl_request(this.url, this.targetParam, true)
			this.list = data || []
			!!this.afterLoad && this.afterLoad.apply(this.context, [this.list])
		},
		/**
		 * 初始化
		 * @author  韦胜健
		 * @date    2019/5/6 17:30
		 */
		async init(staticTable) {
			this.staticTable = staticTable
			if (!this.url || !this.loadOnStart) return
			await this.reload()
		},
		/**
		 * 上一页
		 * @author  韦胜健
		 * @date    2019/9/11 16:08
		 */
		prevPage() {
			if (this.page === 1) return
			this.page--
		},
		/**
		 * 下一页
		 * @author  韦胜健
		 * @date    2019/9/11 16:08
		 */
		nextPage() {
			if (this.page === this.totalPage) return
			this.page++
		},
		/**
		 * 跳转到指定页
		 * @author  韦胜健
		 * @date    2019/5/6 17:30
		 */
		jumpPage(page) {
			if (page < 1) page = 1
			if (page > this.totalPage) page = this.totalPage
			this.page = page - 0
		},
		/**
		 * 修改选中行
		 * @author  韦胜健
		 * @date    2019/8/28 11:13
		 */
		async changeSelectRow(realRowIndex) {
			const pageRowIndex = this.getPageRowIndex(realRowIndex)
			this.p_changeSelectRow(pageRowIndex)
		},
		/**
		 * 将对象在当前页索引转变为对象在数据数组中的真实索引
		 * @author  韦胜健
		 * @date    2019/8/28 11:39
		 */
		getRealRowIndex(pageRowIndex) {
			return ((this.page - 1) * this.pageSize) + pageRowIndex
		},
		/**
		 * 将对象在数组中的真实索引转变为当前页行索引
		 * @author  韦胜健
		 * @date    2019/8/28 14:04
		 */
		getPageRowIndex(realRowIndex) {
			return realRowIndex - (((this.page - 1) * this.pageSize))
		},
		/**
		 * 上移一行数据
		 * @author  韦胜健
		 * @date    2019/8/29 09:21
		 */
		async moveUp() {
			if (!this.selectRow) {
				this.$dialog.show('请选中一行数据')
				return
			}
			const realIndex = this.selectIndex
			if (realIndex === 0) return
			const list = this.$lv.$utils.deepCopy(this.list)
			list.splice(realIndex - 1, 0, list.splice(realIndex, 1)[0])
			this.list = list
			await this.$lv.nextTick()
			if (this.getPageRowIndex(realIndex) === 0) {
				this.jumpPage(this.page - 1)
				await this.$lv.nextTick()
			}
			this.changeSelectRow(realIndex - 1)
		},
		/**
		 * 下移一行数据
		 * @author  韦胜健
		 * @date    2019/8/29 09:21
		 */
		async moveDown() {
			if (!this.selectRow) {
				this.$dialog.show('请选中一行数据')
				return
			}
			const realIndex = this.selectIndex
			if (realIndex === this.list.length - 1) return
			const list = this.$lv.$utils.deepCopy(this.list)
			list.splice(realIndex, 0, list.splice(realIndex + 1, 1)[0])
			this.list = list
			await this.$lv.nextTick()
			if (this.getPageRowIndex(realIndex) === (this.pageSize - 1)) {
				this.jumpPage(this.page + 1)
				await this.$lv.nextTick()
			}
			this.changeSelectRow(realIndex + 1)
		},
		/**
		 * 删除一行数据（在调用这个方法之前，需要自行调用接口先删除后端的数据）
		 * @author  韦胜健
		 * @date    2021/1/11 20:55
		 */
		async deleteRow(row) {
			let index = this.list.indexOf(row)
			this.list.splice(index, 1)
			if (index >= this.list.length) {
				index = this.list.length - 1
			}
			await this.$lv.nextTick()
			if (this.pageData.length === 0) {
				this.prevPage()
			}
			this.p_changeSelectRow(this.getPageRowIndex(index))
		},


		/**
		 * 修改当前显示也的选中行，
		 * @author  韦胜健
		 * @date    2019/8/28 13:55
		 */
		async p_changeSelectRow(pageRowIndex) {
			this.p_selectIndex = null
			await this.$lv.nextTick()
			this.p_selectIndex = pageRowIndex
		},
		/**
		 * 发送请求
		 * @author  韦胜健
		 * @date    2019/5/6 17:30
		 */
		async pl_request(...args) {
			this.loading = true
			try {
				const {rows, success, result, total} = await this.context.$http.post(...args)
				// console.log({rows, success, result, total})
				if (!success) {
					console.error('Static option error: ', result)
					return Promise.reject(result)
				} else
					return Promise.resolve(rows)
			} catch (e) {
				console.error(e)
				return Promise.reject(e)
			} finally {
				this.loading = false
			}
		},
		/**
		 * 处理排序变化
		 * @author  韦胜健
		 * @date    2019/5/6 17:30
		 */
		pl_sortChange({field, desc}) {
			this.sortField = field
			this.sortDesc = desc
			this.page = 1
			this.refreshListData()
		},
		/**
		 * 处理表格初始化
		 * @author  韦胜健
		 * @date    2019/5/6 17:31
		 */
		pl_collect(columns) {
			this.renderColumns = columns
			this.filterOptions = []
			columns.forEach(column => {
				if (!!column.search) {
					if (column.filterName === 'picklist') {
						const {option, showKey, map} = column.externalData
						this.filterOptions.push({
							field: column.field,
							type: 'picklist',
							name: column.title,
							isLink: true,
							defaultSearch: this.searchField === column.field,
							pickProps: {
								option: option,
								title: option.title,
								show: false,
								disabled: false,
								showKey: showKey,
								pickMap: map,
								reverseMap: true,
								placeholder: '请选择'
							}
						});
					} else {
						this.filterOptions.push({
							field: column.field,
							name: column.title,
							lov: column.lov,
							lnkType: column.filterName === 'input' ? 'normal' : column.filterName,
							defaultSearch: this.searchField === column.field
						});
					}
				}

				!!column.quickFilter && this.quickfilterOptions.push({
					field: column.field,
					name: column.title,
					lov: column.lov
				});
			})

		},
		/**
		 * 处理快速筛选变化
		 * @author  韦胜健
		 * @date    2019/5/6 17:31
		 */
		pl_quickFilterChange(e) {
			this.quickfilterValue = e;
			this.page = 1
			this.refreshListData()
		},
		/**
		 * 单字段筛选变化
		 * @author  韦胜健
		 * @date    2019/5/6 19:07
		 */
		pl_singleFilterChange() {
			this.page = 1
			this.refreshListData()
		},
		/**
		 * 监听点击行动作
		 * @author  韦胜健
		 * @date    2019/8/28 11:11
		 */
		async pl_rowClick({row, rowIndex}) {
			this.p_changeSelectRow(rowIndex)
		},
		/**
		 * 判断是否通过复合筛选条件
		 * @author  韦胜健
		 * @date    2019/5/6 19:07
		 */
		filterValidate(filter, item) {
			let val = item[filter.property]
			filter.operator = filter.operator || '='
			switch (filter.operator) {
				case 'in':
					let filterVals = filter.value.replace(/[\[\]]/g, '').split(',')
					// console.log(1,item[filter.property],filterVals);
					return filterVals.indexOf(item[filter.property]) > -1
				case '=':
					// console.log(2);
					return val === filter.value
				case '>=':
					// console.log(3);
					if (filter.type === 'date') {
						val = this.$lv.$utils.dateParse(val, 'YYYY-MM-DD HH:mm:ss').getTime()
						let filterVal = this.$lv.$utils.dateParse(filter.value, 'YYYY-MM-DD HH:mm:ss').getTime()
						return val >= filterVal
					} else {
						return (val - 0) >= (filter.value - 0)
					}
				case '<=':
					// console.log(4);
					if (filter.type === 'date') {
						val = this.$lv.$utils.dateParse(val, 'YYYY-MM-DD HH:mm:ss').getTime()
						let filterVal = this.$lv.$utils.dateParse(filter.value, 'YYYY-MM-DD HH:mm:ss').getTime()
						return val <= filterVal
					} else {
						return (val - 0) <= (filter.value - 0)
					}
				case 'LIKE':
					// console.log(5, val, filter.value);
					return (val || '').toString().indexOf(filter.value) > -1
			}
		},
		/**
		 * 刷新列表数据，重新处理筛选，排序，分页
		 * @author  韦胜健
		 * @date    2019/7/4 14:49
		 */
		refreshListData() {
			let data = [...(this.list || [])];
			// console.log(this.filtersRaw)
			/*筛选*/
			if (!!this.filtersRaw && this.filtersRaw.length > 0) {
				data = data.filter(item => {
					return this.filtersRaw.reduce((ret, filter) => {
						if (!ret) return ret
						return this.filterValidate(filter, item)
					}, true)
				})
			}
			/*排序*/
			if (!!this.sortField && this.sortDesc != null) {
				data.sort((a, b) => {
					if (this.$lv.$utils.isNumber(a[this.sortField]) && this.$lv.$utils.isNumber(b[this.sortField]))
						return (a[this.sortField] - b[this.sortField]) * (this.sortDesc ? -1 : 1)
					else if (!a[this.sortField] || !b[this.sortField]) {
						return !a[this.sortField] ? -1 : 1
					} else {
						return a[this.sortField].localeCompare(b[this.sortField]) * (this.sortDesc ? -1 : 1)
					}
				})
			}
			this.listData = data
		},
	},

}

class StaticOption extends Vue {

	static DEFAULT_STATIC_OPTION = DEFAULT_STATIC_OPTION

	constructor(option) {
		super(component)
		Object.assign(this, option)
	}
}

export default StaticOption;
